import { msg } from '@gonfalon/messages/msg';
import { Icon } from '@launchpad-ui/icons';

import styles from './EmptyChart.module.css';

export type EmptyChartProps = {
  title?: string;
  subtitle?: string;
};

export function EmptyChart({
  title = msg('dataviz.emptyState.heading'),
  subtitle = msg('dataviz.emptyState.body'),
}: EmptyChartProps) {
  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <Icon name="chart-histogram" size="medium" className={styles.icon} />
        <div className={styles.textContainer}>
          <p className={styles.title}>{title}</p>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
      </div>
    </div>
  );
}
